<template>
  <aside class="menu app-sidebar animated" :class="{ slideInLeft: show, slideOutLeft: !show }">
    <ul class="menu-list">
      <li
        v-for="(item, index) in menu"
        v-show="((item.meta.auth && $auth.check() && checkMenuAllowed(item)) || !item.meta.auth)"
        :key="index"
        class="topItem"
        :class="{'disabledMenu' : !(!item.meta.needsOnderzoek || item.meta.needsOnderzoek && onderzoek.id)}"
      >
        <router-link
          v-if="item.path"
          :to="generatePath(item)"
          :exact="true"
          :aria-expanded="!!isExpanded(item)"
          @click.native="toggle(index, item)"
        >
          <span class="icon is-small">
            <i :class="['fa', item.meta.icon]" />
          </span>
          {{ $t(item.meta.label) || $t(item.name) }}
          <span
            v-show="item.children && item.children.length && (!item.meta.needsOnderzoek || item.meta.needsOnderzoek && onderzoek.id)"
            class="icon is-small is-angle"
          >
            <i class="fa fa-angle-down" />
          </span>
        </router-link>
        <a v-else :aria-expanded="isExpanded(item)" @click="toggle(index, item)">
          <span class="icon is-small">
            <i :class="['fa', item.meta.icon]" />
          </span>
          {{ $t(item.meta.label) || $t(item.name) }}
          <span
            v-show="item.children && item.children.length && (!item.meta.needsOnderzoek || item.meta.needsOnderzoek && onderzoek.id)"
            class="icon is-small is-angle"
          >
            <i class="fa fa-angle-down" />
          </span>
        </a>
        <ul v-if="isExpanded(item)">
          <li v-if="(item.meta.needsOnderzoek && onderzoek.inventarisatie_asset)" class="subItem">
            <a
              v-if="item.meta.needsOnderzoek && onderzoek.inventarisatie_asset"
              class="subTitle"
            >{{ onderzoek.inventarisatie_asset.asset.straatnaam + ' ' + onderzoek.inventarisatie_asset.asset.huisnummer }}</a>
          </li>
          <li
            v-for="subItem in item.children"
            v-show="subItem.path"
            :key="subItem.name"
            class="subItem"
          >
            <router-link
              :to="generatePath(item, subItem)"
            >{{ subItem.meta&& $t(subItem.meta.label) || $t(subItem.name) }}</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </aside>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      isReady: false
    }
  },
  computed: {
    ...mapGetters({
      menu: 'menuitems'
    }),
    ...mapState({
      project: state => state.projectmanagement.project,
      onderzoek: state => state.projectmanagement.onderzoek,
      active_user: state => state.management.active_user
    })
  },
  watch: {
    $route(route) {
      this.isReady = true
      this.shouldExpandMatchItem(route)
    },
    onderzoek() {
      this.shouldExpandMatchItem(this.$route, true)
    },
    project() {
      this.shouldExpandMatchItem(this.$route, true)
    }
  },
  mounted() {
    const route = this.$route
    if (route.name) {
      this.isReady = true

      this.shouldExpandMatchItem(route)
    }
  },
  methods: {
    ...mapActions(['expandMenu']),

    checkMenuAllowed(item) {
      if (item.meta.allowed_roles) {
        if (!this.active_user?.inventarisatie_user) return false
        return item.meta.allowed_roles.includes(
          this.active_user.inventarisatie_user.inventarisatie_rol.id
        )
      } else {
        return true
      }
    },
    isExpanded(item) {
      console.log(item);
      return item.meta.expanded
    },
    toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      })
    },
    shouldExpandMatchItem(route, twice) {
      const matched = route.matched
      const lastMatched = matched[matched.length - 1]
      let parent = lastMatched && (lastMatched.parent || lastMatched)
      const isParent = parent === lastMatched

      if (isParent) {
        const p = this.findParentFromMenu(route)
        if (p) {
          parent = p
        }
      }

      if (parent?.meta && 'expanded' in parent.meta && !isParent) {
        this.expandMenu({ index: -1, item: parent, expanded: true })
        if (twice) {
          this.expandMenu({ index: -1, item: parent, expanded: false })
          setTimeout(
            () => this.expandMenu({ index: -1, item: parent, expanded: true }),
            300
          )
        }
      }
    },
    generatePath(item, subItem) {
      let parentPath = `${item.component ? item.path : ''}`

      // TODO way to implement router params in generated routes. Only works for one sublevel
      if (item.storeEntry) {
        const props = item.storeEntry.split('.')

        let object = this.$store.state

        for (let i = 0; i < props.length; i++) {
          object = object[props[i]]
        }
        parentPath = parentPath.split(':')[0]

        parentPath += `${object}`

        if (item.children?.length && !subItem) {
          subItem = item.children[0]
        }
      } else if (item.children?.length && !subItem) {
        subItem = item.children[0]
      }

      return `${parentPath}${subItem ? '/' + subItem.path : ''}`
    },
    findParentFromMenu(route) {
      const menu = this.menu
      for (let i = 0, l = menu.length; i < l; i++) {
        const item = menu[i]
        const k = item.children?.length
        if (k) {
          for (let j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "~styles/variables.scss";

.app-sidebar {
  position: fixed;
  top: 52px;
  left: 0;
  bottom: 0;
  padding: 20px 0 50px;
  width: $sidebar-width;
  min-width: 45px;
  max-height: 100vh;
  height: calc(100% - 50px);
  z-index: 1024 - 1;
  background: #fff;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
  overflow-y: auto;
  overflow-x: hidden;

  @include mobile() {
    transform: translate3d(-180px, 0, 0);
  }

  .icon {
    vertical-align: middle;

    &:first-child {
      margin-right: 7px;
    }
    &.is-angle {
      position: absolute;
      right: 10px;
      transition: transform 0.377s ease;
    }
  }

  .menu-label {
    padding-left: 5px;
  }

  .menu-list {
    padding-left: 0;
    .disabledMenu {
      a {
        pointer-events: none;
        color: lightgrey;
      }
      cursor: not-allowed;
      color: lightgrey;
    }

    a {
      color: #6f6f6e;
      display: flex;
      align-items: center;
      border-radius: 0;

      &.is-active {
        color: $brand-kiwa-alt;
        background-color: white;
        border-left: 4px solid $brand-kiwa-alt;
        padding-left: 0.5em;
      }

      &:hover {
        background-color: whitesmoke;
        color: $brand-kiwa-alt;
      }
    }

    li a {
      &[aria-expanded="true"] {
        .is-angle {
          transform: rotate(180deg);
        }
      }
    }

    .subTitle {
      pointer-events: none;
      font-style: italic;
    }

    .subItem {
      a {
        box-sizing: border-box;
        border-bottom: 1px solid transparent;
        padding-left: 35px;
        &.is-active {
          color: $brand-kiwa-alt;
          background-color: rgba(0, 0, 0, 0.018);
          border-left: 0;
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.018);
          color: $brand-kiwa-alt;
        }
      }
    }

    li {
      ul {
        border-left: 0 solid $brand-kiwa-alt;
        box-shadow: inset 0 2px 3px lightgray;
      }

      a + ul {
        margin: 0;
        padding-left: 0;
        box-shadow: none;
        background-color: #f6f6f6;
      }
    }
  }

  .subTitle {
    font-size: 0.8em;
  }
}
</style>
